const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the filtered content search bar directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Videos} Videos the resource defined to manage Videos
 * @argument {Files} Files the resource defined to manage Files
 */
app.directive('presentationExistingContent', ['Videos', 'Files', '$q', function (Videos, Files, $q) {
  return {
    restrict: 'E',
    scope: {
      onSelect: '&',
      type: '='
    },
    template: require('../../templates/directives/presentation-existing-content.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      // Available query types: department|location|text
      self.searchText = '';
      self.queryIds = {};
      self.queries = [];
      self.activeFilter = '';
      self.placeholder = 'Search for existing Files and Videos';

      self.cancel = function() {
        self.searchText = '';
        $scope.type = null;
      };

      self.updateQuery = function(tag) {
        var item = {};

        switch (tag.type) {
          case 'videos':
            item.source = tag.source === 'custom' ? 'video' : tag.source;
            item.title = tag.text;
            item.link = tag.link;
            item.source_id = tag.source_id || null;
            item.type = 'video';
            break;
          case 'files':
            item.type = 'file';
            item.link = tag.link;
            item.fileName = tag.text;
            break;
          default:
            break;
        }
        self.searchText = '';
        $scope.onSelect({item: item});
      };

      // ------------- start ngTag triggered actions ------------
      self.addingTag = function($tag) {
        self.updateQuery($tag);
        return false;
      };

      // ------------- End ngTag triggered actions ------------



      self.searchContent = function(query) {
        var promises = [];
        promises.push(Files.find(query).$promise);
        promises.push(Videos.find(query).$promise);

        return $q.all(promises);
      };

      self.getOptions = function(input) {
        var deferred = $q.defer();

        input = input ? input.toLowerCase() : '';
        var placeholders = {
          files: {name: 'Files', text: 'Files', _id: 'files', placeholder: true},
          videos: {name: 'Videos', text: 'Videos', _id: 'videos', placeholder: true},
        };

        var addedItems = {
          files: false,
          videos: false,
        };

        var query = {
          subresource: '',
          page: 1,
          per_page: 10,
          fields: 'title,link,source,source_id,type',
          title: '$regex,2,' + input + ',i',
          sort: 'title,-1'
        };

        self.searchContent(query)
        .then(function(results) {
          var items = [];
          // Add content to options
          for (var i = 0; i < results.length; i++) {
            for (var j = 0; j < results[i].length; j++) {
              var type = i === 0 ? 'files' : 'videos';
              var item = results[i][j];
              if (!item || !item.title || !item._id) {
                continue;
              }
              if (!addedItems[type]) {
                items.push(placeholders[type]);
                addedItems[type] = true;
              }
              items.push({
                name: item.title,
                text: item.title,
                link: item.link,
                source: item.source,
                source_id: item.source_id,
                _id: item._id,
                type: type, 
              }); 
            }
          }
          deferred.resolve(items);
        });

        return deferred.promise;
      };

    }],
    controllerAs: 'existing'
  }
}]);